
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/produit/[slug]",
      function () {
        return require("private-next-pages/produit/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/produit/[slug]"])
      });
    }
  